import { UserMemberSubscriptionStatus } from "@gymflow/types";
import { Status, StatusColorType } from "apps/portal/src/components/atoms";
import { capitalize } from "lodash";

type CreditPackItemStatusProps = {
  status: UserMemberSubscriptionStatus;
};

const STATUS_MAP: Partial<
  Record<UserMemberSubscriptionStatus, StatusColorType>
> = {
  PENDING: "lightblue",
  PAUSED: "warning",
  OVERDUE: "error",
  CANCELLED: "warning",
};

export const CreditPackItemStatus = ({ status }: CreditPackItemStatusProps) => {
  const color = STATUS_MAP[status];

  if (!color) return null;

  return (
    <>
      <Status text={capitalize(status)} statusColor={color} />
      {status !== "CANCELLED" && status !== "PENDING" && (
        <div className="h-1.5 w-1.5 shrink-0 rounded-full bg-gray-300" />
      )}
    </>
  );
};
